
import { getTodayForDisplay } from "@/utils/dateUtils";

export function GameResultHeader() {
  const displayDate = getTodayForDisplay();

  return (
    <header className="text-center mb-4 relative w-full">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Match My Logic: Daily</h1>
      <p className="text-sm sm:text-base text-gray-600 mt-0">
        {displayDate}
      </p>
    </header>
  );
}
